import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/noData.png'


const _withScopeId = n => (_pushScopeId("data-v-5ec187d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-opBgColor flex flex-col items-center py-[25px]" }
const _hoisted_2 = { class: "flex w-[1200px] mt-[25px] min-h-[850px]" }
const _hoisted_3 = { class: "bg-opWhite basis-[250px] mr-[15px]" }
const _hoisted_4 = {
  key: 0,
  class: "text-center pt-[20px] text-opTextSecond"
}
const _hoisted_5 = { class: "bg-opWhite flex-1 p-[25px]" }
const _hoisted_6 = {
  id: "viewerId",
  style: {"width":"100%"}
}
const _hoisted_7 = { class: "flex w-full h-full flex-col justify-center items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_9 = { class: "my-[10px] text-opTextSecond" }

import { MenuItemInterface } from '@/types'
import MenuItem from '@/components/Menu/MenuItem.vue'
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import Axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import Editor from '@toast-ui/editor'
import { Viewer } from '@toast-ui/editor/types'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionView',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { locale, t } = useI18n()
const isZh = ref(locale.value === 'zh-CN')

const editLoading = ref(false)
let viewer:Viewer|null = null
const initViewer = () => {
  viewer = Editor.factory({
    el: document.querySelector('#viewerId') as HTMLElement,
    viewer: true,
    initialValue: ''
  })
}
const routerWatch = watch(route, () => {
  dealRouteQuery()
})

onMounted(() => {
  initViewer()
})
onUnmounted(() => {
  if (!viewer) return
  viewer.destroy()
  routerWatch()
})

// 一级菜单、二级菜单
const activeSecondMenu = ref(0)
const secondMenuList = ref <MenuItemInterface[]>([])
let secondMenu :number
// 选择二级菜单显示文档
const selectMenu = (menuId:string) => {
  router.push({
    path: '/question',
    query: {
      secondMenu: menuId + ''
    }
  })
}
const showDocument = async () => {
  try {
    if (!route.query?.secondMenu) return
    const menuId = route.query?.secondMenu
    editLoading.value = true
    activeSecondMenu.value = Number(menuId)
    const apiLang = isZh.value ? 'zh-CN' : 'en'
    const { data: resData } = await Axios.get(`/openapi/console/noLogin/online/doc/${menuId}/${apiLang}?time=${new Date().getTime()}`)

    if (resData.code === 0 && resData.data?.content) {
    // 存在跨域，需截断用代理
      const mdUrl = resData.data.content.replace(
        'https://storage.googleapis.com',
        ''
      )
      const { data: contentData } = await Axios.get(`${mdUrl}`)
      viewer && viewer.setMarkdown(contentData + '' || '')
      editLoading.value = false
    } else {
      viewer && viewer.setMarkdown('')
      editLoading.value = false
    }
  } catch (error) {
    editLoading.value = false
  }
}

// 处理获取二级目录下默认第一个文档
const findSecondMenuDefaultId = (data:MenuItemInterface[]):number => {
  let resultId:number|null = null
  const findFirstDoc = (menuTree:MenuItemInterface[]) => {
    menuTree.forEach(item => {
      if (resultId) return
      item.menuType === '1' && (resultId = item.id)
      findFirstDoc(item.subMenuList)
    })
  }
  findFirstDoc(data)
  return resultId ?? 0
}
// 监听路由重置
const dealRouteQuery = () => {
  if (route.name !== 'question') return
  secondMenu = Number(route.query?.secondMenu) ?? 0
  //   选中二级菜单
  if (secondMenu) {
    activeSecondMenu.value = secondMenu
    showDocument()
  } else {
    router.push({
      path: '/question',
      query: {
        secondMenu: findSecondMenuDefaultId(secondMenuList.value) + ''
      }
    })
  }
}
const viewLoading = ref(false)
const getMenuList = async () => {
  try {
    viewLoading.value = true
    const { data: ResData } = await Axios.get<{data:MenuItemInterface[]}>(`/openapi/console/noLogin/online/doc/menu/list?time=${new Date().getTime()}`)
    viewLoading.value = false
    const documentMenu = ResData.data?.find(item => {
      return (item.id === 2 || item.menuNameCn === '常见问题' || item.menuNameEn === 'common problem') && item.pid === 0
    })
    documentMenu && (secondMenuList.value = documentMenu?.subMenuList)
    dealRouteQuery()
  } catch (error) {
    viewLoading.value = false
  }
}
getMenuList()


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(MenuItem, {
            menuData: secondMenuList.value,
            defaultActive: activeSecondMenu.value,
            isZh: isZh.value,
            selctFun: selectMenu
          }, null, 8, ["menuData", "defaultActive", "isZh"]),
          (!secondMenuList.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('noData')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
          [_vShow, activeSecondMenu.value!==0]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('noDocument')), 1)
        ], 512), [
          [_vShow, activeSecondMenu.value===0]
        ])
      ])), [
        [_directive_loading, editLoading.value]
      ])
    ])
  ])), [
    [_directive_loading, viewLoading.value]
  ])
}
}

})